angular.module('app.directives.checkout').directive('checkoutAddOns', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
    },
    controller: function ($scope) {
      $scope.scoreboardAssistQuantity = 0;
    },
    template: `
        <div class="pricing-col encoder-options" style="margin-bottom: 15px;">
          <div class="add-on-container">
            <div ng-repeat="addOn in vm.addOns">
              <p class="price" style="text-align: right;" ng-hide="addOn.monthlyCost == 0">{{ addOn.monthlyCost | currency }}/mo.
              <span ng-hide="addOn.priceSubtext == ''" style="font-size:12px; font-weight:normal"><br>{{ addOn.priceSubtext }}</span></p>
              <div class="checkbox" style="margin-bottom:25px" ng-if="vm.checkPlanRequirements(addOn.requirements.plan) && vm.checkEncoderRequirements(addOn.requirements.encoder)">
              <label ng-if="addOn.enabled">
                    <input type="checkbox" name="{{ addOn.title }}" ng-model="addOn.selected" ng-value="addOn.title">
                    {{ addOn.title }}
                </label>
                <label ng-if="!addOn.enabled" style="cursor: not-allowed">
                  <input type="checkbox" name="{{ addOn.title }}" ng-model="addOn.selected" ng-value="addOn.title" ng-disabled="true">
                  {{ addOn.title }}
                </label>
                <div class="subtext" ng-if="addOn.enabled">{{ addOn.description }}</div>
                <div class="subtext" ng-if="!addOn.enabled">{{ addOn.description }} <br>                  
                  <a href="javascript://" ng-click="vm.popChatOrSchedule()">Contact sales for help getting this add-on.</a>
                </div>
                <div class="subtext" style="font-weight: bold; margin-top:8px;" ng-if="addOn.costPerStream">This add-on applies to all streams in a plan.</div>
                <div ng-if="addOn.selected && addOn.quantityInput " class="subtext add-on-quantity">
                  <input type="number" name="{{ addOn.varName }}_quantity" step="1" ng-model="addOn.quantity" min="1" max="10">
                  <div class="small-text"><span style="font-weight:bold;">{{addOn.quantityInputHeadline}}</span><br>
                  {{addOn.quantityInputText[vm.selectedBasePlan]}}</div>
                </div>
                <div ng-if="addOn.selected && addOn.varName == 'scoreboard'">
                  <div class="subtext add-on-quantity">
                    <input type="number" name="{{ addOn.varName }}_quantity" step="1" ng-model="addOn.oneTimeCost.quantity" min="1" max="10">
                    <div class="small-text">
                      <span style="font-weight:bold;">{{addOn.quantityInputHeadline}}</span><br>
                      {{addOn.quantityInputText[vm.selectedBasePlan]}}<br>
                      <div class="text-danger" style="padding-left:0;">{{vm.scoreboardAssistProduct.checkout_message}}</div>
                    </div>
                  </div>
                </div>
                <div ng-if="addOn.varName == 'scoreboard'" class="subtext add-on-alert">
                  <div>Sign up for BoxCast’s Automatic Scoreboard Overlays and receive your first Scoreboard Assist free! Additional devices are $599 each.</div>
                </div>
              </div>
                <div class="checkbox" style="margin-bottom:25px" ng-if="!vm.checkPlanRequirements(addOn.requirements.plan) || !vm.checkEncoderRequirements(addOn.requirements.encoder)">
                  <label>
                  <input type="checkbox" name="add_scoreboard" ng-model="vm.addScoreboard" value="add_scoreboard" ng-disabled="true" disabled="disabled">
                  {{ addOn.title }}
                  </label>
                <div class="subtext">{{ addOn.description }}</div>
                <div class="subtext text-danger">{{addOn.title}} requires:</div>
                <ul class="text-danger">
                    <li class="subtext" ng-if="!vm.checkPlanRequirements(addOn.requirements.plan)">The Experience Plan <span ng-click="vm.goto(1)"><a href="javascript://">Switch to The Experience Plan</a></span></li>
                    <li class="subtext" ng-if="!vm.checkEncoderRequirements(addOn.requirements.encoder)">A BoxCaster or BoxCaster Pro <span ng-click="vm.goto(2)"><a href="javascript://">Add a BoxCaster</a></span></li>
                </ul>
              </div>
            </div>
          </div>
        </div> `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/checkout/checkout-add-ons.js